import React, { Component } from 'react'

import { get } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { submit } from 'redux-form'

import uberFacts from '../../../../../assets/usageTips/tips.json'
import SliderWrapper from '../../../../../components/renderPropComponents/SliderWrapper'
import BlankCard from '../../../../../components/ui/cards/BlankCard'
import LottieLoader from '../../../../../components/ui/lotties/LottieLoader'
import SearchHistoryPanel from '../../../../../components/ui/SearchHistory/SearchHistoryPanel/SearchHistoryPanel'
import selectors from '../../../../../store/shared/selectors'
import { pickWithDefaults } from '../../../../../utils/data'
import withEducation from '../../../../../utils/graphql/hocs/withEducation'
import notificationsUtils from '../../../../../utils/notifications/notificationsUtils'
import {
  dataToGauge,
  getEducationInsight,
} from '../../../../../utils/resumesearch/dataTransformation'
import numberConverter from '../../../../../utils/tuition/numberForCurrency'
import MobileCareerResult from '../../routes/Career/components/mobile/MobileCareerResult'
import Recommendations from '../Career/components/Recommendations'
import Education from '../components/CareerPaths/Education'
import CareerResult from '../components/CareerResult'
import Skills from '../components/Skills'

import EducationResult from './components/EducationResult'
import MajorSearchForm from './components/MajorSearchForm'
import SavedEducationSearchesWrapper from './components/SavedEducationSearches/savedEducationSearchesWrapper'
import * as savedEducationSearchesDuck from './savedEducationSearchesDuck'

const resultHeaders = [
  {
    header: 'Salary Trends After Graduation',
    tipContent:
      'The people matching your search worked in many different fields. See the salary range for each of these possibilities here.',
  },
  {
    header: 'Common Jobs',
    tipContent:
      'Here are some common jobs based on your search. Do any of these jobs sound like fun?',
  },
  {
    header: 'Top Companies',
    tipContent: 'These are the most common companies hiring for this major.',
  },
]

class AuthenticatedSearchEducationIndex extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstRenderWithData: false,
    }

    this.defaultEducationData = {
      advancedDegrees: [],
      careerBreakdown: {},
      careerPathData: [],
      commonJobSalary: [],
      degreeDrilldown: {},
      educationBreakdown: {},
      highestPayingJob: {},
      predictedSalary: 0,
      recommendedCareerSearches: [],
      recommendedEducationSearches: [],
      salaryTrend: {},
      searchClassification: {},
      topJobsSalary: [],
      totalSearchMatches: 0,
      skills: [],
      topCompanies: [],
      yearsToPosition: 0,
    }

    this.saveEducationSearch = () => {
      this.props
        .performSaveEducationSearch({
          searchParams: Object.assign({}, this.props.searchFormValues),
        })
        .then(() => notificationsUtils.showSuccessNotification('Saved Results Successfully!'))
    }

    this.handleFormSubmit = e => {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      const { getEducationData, searchFormValues } = this.props
      if (this.state.firstRenderWithData) this.setState({ firstRenderWithData: false })
      getEducationData(searchFormValues)
    }
  }

  componentWillMount() {
    const { gaugeFieldData, performRetrieveSavedEducationSearches, userId } = this.props

    if (gaugeFieldData && gaugeFieldData.length) this.setState({ firstRenderWithData: true })
    performRetrieveSavedEducationSearches({ user_id: userId })
  }

  componentDidMount() {
    setTimeout(() => {
      const { searchType, search_query } = this.props.queryParams
      if (searchType === 'education' && search_query) {
        this.props.submit('majorSearchForm')
      }
    })
  }

  render() {
    const {
      isMobile,
      onChangeResultsPage,
      openModal,
      performDeleteSavedEducationSearch,
      queryParams,
      salaryInsight,
      savedEducationSearches,
      searchClassificationString,
      searchError,
      searchFormValues,
      titles,
      educationData,
      loadingEducationData,
      setEducationData,
    } = this.props

    const {
      advancedDegrees,
      careerBreakdown,
      commonJobSalary,
      degreeDrilldown,
      educationBreakdown,
      highestPayingJob,
      predictedSalary,
      recommendedCareerSearches,
      recommendedEducationSearches,
      salaryData,
      salaryTrend,
      searchClassification,
      topJobsSalary,
      totalSearchMatches,
      skills,
      insTokenOrgName,
      topCompanies,
      yearsToPosition,
      workedInRelatedField,
      studiedMajorOtherThanSearch,
    } = pickWithDefaults(educationData, this.defaultEducationData)

    const gaugeFieldData = dataToGauge(workedInRelatedField)
    const advancedDegreeData = dataToGauge(advancedDegrees)
    const gaugeMajorData = dataToGauge(studiedMajorOtherThanSearch)
    const educationInsight = getEducationInsight(educationData)
    const searchTerm = get(searchFormValues, 'search_query')

    const isEmptyData =
      educationData &&
      typeof educationData === 'object' &&
      (Object.keys(educationData).length === 0 || educationData.totalSearchMatches === 0)

    let pageTitles = null
    if (skills && skills.length > 0) pageTitles = titles
    else {
      pageTitles = [...titles]
      pageTitles.splice(3, 1)
    }
    if (isMobile) pageTitles.splice(2, 1)

    const clearResults = () => {
      setEducationData(this.defaultEducationData)
      this.props.resetFormValues()
    }

    const dataComponent = (
      <BlankCard notCard style={{ marginTop: 10, marginBottom: 10, paddingLeft: 16 }} delay={0.5}>
        <div>
          <h6 className="text-muted" style={{ marginLeft: -15 }}>
            Hooray! Your search matched
            <strong style={{ color: '#808080' }}>
              {' '}
              {totalSearchMatches === 100000
                ? 'over 100,000'
                : numberConverter(totalSearchMatches)}{' '}
            </strong>
            real people.
          </h6>
          <SliderWrapper
            isMobile={isMobile}
            onSaveSearch={this.saveEducationSearch}
            recMajors={recommendedEducationSearches}
            recJobs={recommendedCareerSearches}
            saveSearchHidden={gaugeFieldData === null}
            titles={pageTitles}
            clearResults={clearResults}
            openModal={openModal}
          >
            {activeIndex => {
              switch (activeIndex) {
                case 0:
                  return (
                    <EducationResult
                      careerBreakdown={careerBreakdown}
                      gaugeMajorData={gaugeMajorData}
                      zoomEducationData={educationBreakdown}
                      advancedDegreeData={advancedDegreeData}
                      zoomDegreeData={degreeDrilldown}
                      searchTerm={searchTerm}
                      isMobile={isMobile}
                      onChangeResultsPage={onChangeResultsPage}
                      insight={educationInsight}
                      searchClassificationString={searchClassificationString}
                    />
                  )
                case 1:
                  return isMobile ? (
                    <MobileCareerResult
                      commonJobSalaryData={commonJobSalary}
                      highestPayingJobData={highestPayingJob}
                      predictedSalary={predictedSalary}
                      salaryData={salaryData}
                      searchClassification={searchClassification}
                      isMobile={isMobile}
                      searchType="education"
                      resultHeaders={resultHeaders}
                      onChangeResultsPage={onChangeResultsPage}
                      insight={salaryInsight}
                      topCompanies={topCompanies}
                      yearsToPosition={yearsToPosition}
                      topJobsSalaryData={topJobsSalary}
                    />
                  ) : (
                    <CareerResult
                      commonJobSalaryData={commonJobSalary}
                      highestPayingJobData={highestPayingJob}
                      predictedSalary={predictedSalary}
                      salaryData={salaryTrend}
                      searchClassification={searchClassification}
                      searchType="education"
                      isMobile={isMobile}
                      resultHeaders={resultHeaders}
                      onChangeResultsPage={onChangeResultsPage}
                      insight={salaryInsight}
                      topCompanies={topCompanies}
                      yearsToPosition={yearsToPosition}
                      topJobsSalaryData={topJobsSalary}
                    />
                  )
                case 2:
                  return isMobile ? (
                    <Skills isMobile={isMobile} searchTerm={searchTerm} skills={skills} />
                  ) : (
                    <Education isMobile={isMobile} onChangeResultsPage={onChangeResultsPage} />
                  )
                case 3:
                  return <Skills isMobile={isMobile} searchTerm={searchTerm} skills={skills} />
                default:
                  return <div> No Content to show </div>
              }
            }}
          </SliderWrapper>
        </div>
      </BlankCard>
    )

    let renderComponent = null
    if (!gaugeFieldData.length && !loadingEducationData && !searchError) {
      renderComponent = (
        <BlankCard notCard noPad delay={0.4}>
          <div style={{ marginTop: '3rem', textAlign: 'center', height: 1 }}>
            <Recommendations handleFormSubmit={this.handleFormSubmit} recType="education" />
          </div>
        </BlankCard>
      )
    } else if (this.state.firstRenderWithData && !isEmptyData && !searchError) {
      renderComponent = dataComponent
    } else {
      renderComponent = (
        <LottieLoader
          height={500}
          width={300}
          isReady={!loadingEducationData}
          animationName="GRADUATE"
          error={searchError}
          noData={isEmptyData}
          uberFacts={uberFacts}
          loadingTime={5000}
          noMessage
          isMobile={isMobile}
          loadingLottieDivMarginTop={-120}
        >
          {dataComponent}
        </LottieLoader>
      )
    }

    return (
      <div>
        <div>
          <div>
            <MajorSearchForm
              enableReinitialize={
                queryParams.search_query && queryParams.searchType === 'education'
              }
              initialValues={Object.assign(
                {},
                {
                  search_query: null,
                  university: null,
                  exactMatch: false,
                },
                queryParams.searchType === 'education'
                  ? queryParams
                  : { university: insTokenOrgName },
              )}
              handleSubmit={this.handleFormSubmit}
              isEmptyData={isEmptyData}
            />
            {renderComponent}
          </div>
          <SearchHistoryPanel searchFilter="Education">
            <SavedEducationSearchesWrapper
              educationSearches={savedEducationSearches}
              onDelete={performDeleteSavedEducationSearch}
            />
          </SearchHistoryPanel>
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => {
  const getFormValues = selectors.makeGetFormValues()
  return state => ({
    searchFormValues: getFormValues(state.form.majorSearchForm),
    queryParams: selectors.getQueryStringSimply(state),
    isMobile: selectors.isLessThanMedium(state),
    savedEducationSearches: savedEducationSearchesDuck.getSavedEducationSearches(state),
    userId: selectors.getUserId(state),
  })
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performDeleteSavedEducationSearch:
        savedEducationSearchesDuck.performDeleteSavedEducationSearch,
      performRetrieveSavedEducationSearches:
        savedEducationSearchesDuck.performRetrieveSavedEducationSearches,
      performSaveEducationSearch: savedEducationSearchesDuck.performSaveEducationSearch,
      resetFormValues: savedEducationSearchesDuck.resetFormValues,
      submit,
    },
    dispatch,
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withEducation(AuthenticatedSearchEducationIndex))



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Education/AuthenticatedSearchEducationIndex.js